module.exports = __webpack_public_path__ + "img/logo-big.ac58c0e8.png";